import $ from 'jquery'
import _ from 'lodash'
import Vue from 'vue'
import { Store } from 'vuex'
import Component from 'vue-class-component'
import RootState from '../../store/state'
import { EAST, NORTH, SOUTH, WEST } from '../../store/editor/core/state'
import { CONTENTS_CONTAINER_SELECTOR } from '../constants/ContainerSelector'
import { Getters } from '../../store/editor/core/helpers'

const BORDER_WIDTH = 8

interface CssStyle {
  [key: string]: string
}

interface ComponentRect {
  width: number
  height: number
  left: number
  top: number
}

@Component
export default class DropMarkerVue extends Vue {
  $store: Store<RootState>
  timestamp: number = -1  // style の再計算を促すためのタイムスタンプ
  repaint = _.throttle(() => {
    this.doRepaint()
  }, 16)

  get style(): CssStyle {
    if (this.timestamp < 0) {
      return this.hiddenStyle()
    }
    const dropState = Getters.dropState(this.$store)
    const position = (dropState.isVisible) ? dropState.position : undefined
    if (!position) {
      return this.hiddenStyle()
    }
    const component = $('#' + position.componentId)
    if (component.length === 0) {
      return this.hiddenStyle()
    }

    const offset = component.offset() || { left: 0, top: 0 }
    const rect: ComponentRect = {
      width: component.outerWidth() || 0,
      height: component.outerHeight() || 0,
      left: offset.left,
      top: offset.top
    }
    const direction = position.direction
    if (direction === NORTH) {
      return this.northStyle(rect)
    }
    if (direction === SOUTH) {
      return this.southStyle(rect)
    }
    if (direction === WEST) {
      return this.westStyle(rect)
    }
    if (direction === EAST) {
      return this.eastStyle(rect)
    }
    return this.hiddenStyle()
  }

  mounted() {
    $(window).on('resize', this.repaint)
    $(CONTENTS_CONTAINER_SELECTOR).on('scroll', this.repaint)
    this.repaint()
  }

  doRepaint(): void {
    // timestamp を書き換えることで、 Vue に対して computed な値を再計算させる
    this.timestamp = new Date().getTime()
  }

  hiddenStyle(): CssStyle {
    return { display: 'none' }
  }

  northStyle(rect: ComponentRect): CssStyle {
    const style = this.horizontalStyle(rect)
    style.top = (rect.top - (BORDER_WIDTH / 2)) + 'px'
    return style
  }

  southStyle(rect: ComponentRect): CssStyle {
    const style = this.horizontalStyle(rect)
    style.top = (rect.top + rect.height - (BORDER_WIDTH / 2)) + 'px'
    return style
  }

  westStyle(rect: ComponentRect): CssStyle {
    const style = this.verticalStyle(rect)
    style.left = (rect.left - (BORDER_WIDTH / 2)) + 'px'
    return style
  }

  eastStyle(rect: ComponentRect): CssStyle {
    const style = this.verticalStyle(rect)
    style.left = (rect.left + rect.width - (BORDER_WIDTH / 2)) + 'px'
    return style
  }

  horizontalStyle(rect: ComponentRect): CssStyle {
    return {
      display: 'block',
      left: rect.left + 'px',
      width: rect.width + 'px',
      height: BORDER_WIDTH + 'px'
    }
  }

  verticalStyle(rect: ComponentRect): CssStyle {
    return {
      display: 'block',
      top: rect.top + 'px',
      width: BORDER_WIDTH + 'px',
      height: rect.height + 'px'
    }
  }
}
